import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '@app/footer/footer.component';
import { MaterialModule } from '@app/material.module';
import { HomeComponent } from '@app/home/home.component';
import { CommonModule } from '@angular/common';
import { CustomMessageComponent } from '@app/custom-message/custom-message.component';
import { SwiperModule } from 'swiper/angular';



@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    SwiperModule
  ],
  declarations: [
    HomeComponent,
    FooterComponent,
    CustomMessageComponent
  ],
})
export class HomeModule {}